import React, { useEffect, useState } from "react";
import Card from "../Common/Card";
import toast from "react-hot-toast";
import ajaxCounts from "../../util/remote/ajaxCounts";
export default function CompanyCardsComponent() {
  const company_id = Number(localStorage.getItem("FuelFy@company_id"));
  const formatNumber = (num) => Number(num || 0).toLocaleString("en-US");
  const formatCurrency = (num) =>
    Number(num || 0).toLocaleString("en-US") + " UGX";
  const [tanks, setTanks] = useState(0);
  const [pumps, setPumps] = useState(0);
  const [clients, setClients] = useState(0);
  const [totalLitres, setTotalLitres] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [stations, setStations] = useState(0);
  const [loading, setLoading] = useState(false);
  const loadTanks = async () => {
    const res = await ajaxCounts.count_tanks_company({ company_id });
    if (res?.status === "OK") setTanks(res.details || 0);
  };
  const loadPumps = async () => {
    const res = await ajaxCounts.count_pumps_company({ company_id });
    if (res?.status === "OK") setPumps(res.details || 0);
  };
  const loadClients = async () => {
    const res = await ajaxCounts.count_users_company({ company_id });
    if (res?.status === "OK") setClients(res.details || 0);
  };
  const loadSales = async () => {
    const res = await ajaxCounts.company_fuel_sale_sums({ company_id });
    if (res?.status === "OK") {
      setTotalLitres(Number(res.details?.total_litres || 0));
      setTotalAmount(Number(res.details?.total_amount || 0));
    }
  };
  const loadStations = async () => {
    const res = await ajaxCounts.count_station({ company_id });
    if (res?.status === "OK") setStations(res.details || 0);
  };
  const loadAll = async () => {
    setLoading(true);

    loadTanks();
    loadPumps();
    loadClients();
    loadSales();
    loadStations();

    setLoading(false);
  };
  useEffect(() => {
    loadAll();
  }, [company_id]);
  return (
    <div>
      <div className="row row-sm">
        <Card
          value={loading ? "..." : formatNumber(tanks)}
          color="blue"
          icon="fa-brands fa-servicestack"
          title="Number Of Tanks"
        />
        <Card
          value={loading ? "..." : formatNumber(pumps)}
          color="blue"
          icon="fa-solid fa-gas-pump"
          title="Number Of Pumps"
        />
        <Card
          value={loading ? "..." : formatNumber(totalLitres)}
          color="blue"
          icon="fa-solid fa-droplet"
          title="Fuel Volume Sold (Litres)"
        />
        <Card
          value={loading ? "..." : formatNumber(clients)}
          color="blue"
          icon="fa-solid fa-users"
          title="Number Of Users"
        />
        <Card
          value={loading ? "..." : formatNumber(stations)}
          color="blue"
          icon="fa-solid fa-cart-shopping"
          title="Number Of Stations"
        />
        <Card
          value={loading ? "..." : formatCurrency(totalAmount)}
          color="blue"
          icon="fa-solid fa-coins"
          title="Total Revenue"
        />
      </div>
    </div>
  );
}
